import {Injectable} from "@angular/core";
import {NestApiProvider} from "../../nest-api";
import { RequestGetEmpDto } from "../../gd-only/dto/employees.dto";
import { Observable } from "rxjs";

@Injectable()
export class RequestforReportApi {

  private service: string = '';
  private model: string = 'sf6s/requestforReport';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  getEmp(payload: RequestGetEmpDto, queryParams: { page: number, limit: number }): Observable<any> {
    const method: string = 'POST';
    const func: string = 'getEmp';
    if (payload.active === '' || payload.active === null) {
      payload.active = '1'
    }
    const params: RequestGetEmpDto = payload;
    const urlParams: any = queryParams;
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/requestfor-report.api.ts